import { STORE_NAME } from '@intigral/constant';
import { queryOptions } from '@tanstack/react-query';
import h, { getCountry } from '../helpers/common';
import user from '../helpers/user';
import { container } from '@intigral/domain/lib/DataDomain';
import { IThinkAnalyticsService } from '@intigral/domain/lib/application/services/ThinkAnalyticsService';
import { DI } from '@intigral/constant/config/DIContainer';
import { transformResponseList } from '../utils/transformResponse/thinkAnalyticsResponse';
import { moodsQueryKeys } from './useMoodsQuery';
// Extract query parameter from a URL
export function getQueryParam(url, param) {
    const regex = new RegExp(`[?&]${param}=([^&]*)`);
    const match = url.match(regex);
    return match ? decodeURIComponent(match[1]) : null;
}

// Query options for mood VOD
export const moodVodQueryOptions = (category: any) =>
    queryOptions({
        queryKey: moodsQueryKeys.vod(category),
        queryFn: async () => {
            try {
                const { apiKey, identityToken, username, subscriptionGUID } = h.getStore(STORE_NAME.USER) || {};
                const profileName = user.getProfileName();
                const userProfile = user.getProfile();
                const rating = userProfile.newParentalControl || userProfile.parentalControl;
                const country = getCountry();
                const device = h.getDevice();
                const guids = subscriptionGUID.join('|');
                const useCaseId = getQueryParam(category.dataSources[0], 'useCaseId');

                // Call the API
                const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
                const response = await taService.getMoodVod(
                    apiKey,
                    identityToken,
                    profileName,
                    username,
                    device,
                    country,
                    guids,
                    rating,
                    useCaseId
                );

                return transformResponseList(response?.data);
            } catch (err) {
                throw new Error(err?.message || 'An error occurred while fetching mood ondemand data.');
            }
        },
        enabled: !!category?.dataSources?.[0],
        staleTime: 4 * 60 * 1000, // 4 minutes
        gcTime: 8 * 60 * 1000, // 8 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
